<template>
  <div class="m-pop">
    <p class="x-font-color">考试报名</p>
    <div class="m-item x-flex-between"><span>考试</span><div class="m-right">{{exam.examName}}</div></div>
    <div v-if="register.subjectRequired==1" class="m-item x-flex-between">
      <span :class="register.subjectRequired==1 ?  '' : 'm-span'">考试科目</span>
      <div class="m-right" @click="show=true">
        <span v-show="!keMu" class="m-ple">请选择考试科目</span>
        <p v-show="keMu">{{keMu}}</p>
        <van-icon class="m-ico" name="arrow" />
      </div>
    </div>
    <div v-if="register.regionsRequired==1" class="m-item x-flex-between">
      <span :class="register.regionsRequired==1 ?  '' : 'm-span'">考区</span>
      <div class="m-right" @click="setPopup()">
        <span v-if="!kaoQu" class="m-ple">请选择考区</span>
        <p v-else="">{{kaoQu}}</p>
        <van-icon class="m-ico" name="arrow" />
      </div>
    </div>
    <div v-if="register.siteRequired==1" class="m-item x-flex-between">
      <span :class="register.siteRequired==1 ?  '' : 'm-span'">考点</span>
      <div class="m-right" @click="isShow=true">
        <span v-show="!kaoDian" class="m-ple">请选择考点</span>
        <p v-show="kaoDian">{{kaoDian}}</p>
        <van-icon class="m-ico" name="arrow" />
      </div>
    </div>
    <div v-if="register.userAddress==1" class="m-item x-flex-between">
      <span>考生地址</span>
      <div class="m-right">
        <van-field v-model="userAddress" type="textarea" rows="1" autosize placeholder="请输入详细地址" />
      </div>
    </div>
    <div v-if="register.hasGraduation==1" class="m-item x-flex-between">
      <span>在籍状态</span>
      <div class="m-right" @click="shower=true">
        <span v-show="!isName" class="m-ple">请选择在籍状态</span>
        <p v-show="isName">{{isName}}</p>
        <van-icon class="m-ico" name="arrow" />
      </div>
    </div>
    <div v-if="isState+''==='0'" class="m-item x-flex-between">
      <span>毕业时间</span>
      <div class="m-right" @click="showTime=true">
        <span v-show="!timeLine" class="m-ple">请选择毕业时间</span>
        <p v-show="timeLine">{{dayjs(timeLine).format('YYYY-MM')}}</p>
        <van-icon class="m-ico" name="arrow" />
      </div>
    </div>
    <div v-if="register.hasGraduation==1&&register.hasTheoryGrade==1&&isState+''==='0'" class="m-item x-flex-between">
      <span>论文成绩</span>
      <div class="m-right" @click="setOPen()">
        <span v-show="!theoryGrade" class="m-ple">请选择论文成绩</span>
        <p v-show="theoryGrade">{{theoryGrade}}</p>
        <van-icon class="m-ico" name="arrow" />
      </div>
    </div>
    <!--科目-->
    <van-popup v-model="show" position="bottom" round :style="{ height: '45%' }" :close-on-click-overlay="false" get-container="body">
      <div class="m-title">
        <div style="color: #969799" @click="isNo()">取消</div>
        <div>科目</div>
        <div style="color: #576b95" @click="confirm()">确认</div>
      </div>
      <div class="m-pop-content">
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell  v-for="(item, index) in subjectList" clickable :title="item.name" :key="item.id" @click="toggle(index,item)">
              <template #right-icon>
                <van-checkbox :name="item.id" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </van-popup>
    <!--考点-->
    <van-popup v-model="isShow" position="bottom" :close-on-click-overlay="false" get-container="body">
      <van-picker show-toolbar value-key="name" title="选择考点" :columns="siteList" @cancel="cancelOn" @confirm="chooseType"/>
    </van-popup>
    <!--考区-->
    <van-popup v-model="areaShow" position="bottom" :close-on-click-overlay="false" get-container="body">
      <van-picker show-toolbar value-key="name" title="选择考区" :columns="areaList" @cancel="cancelArea" @confirm="chooseArea"/>
    </van-popup>
    <!--在籍状态-->
    <van-popup v-model="shower" position="bottom" :close-on-click-overlay="false" get-container="body">
      <van-picker show-toolbar value-key="name" title="选择在籍状态" :columns="isList" @cancel="cancelOnIs" @confirm="chooseIs"/>
    </van-popup>
    <!--毕业时间-->
    <van-popup v-model="showTime" position="bottom" :close-on-click-overlay="false" :style="{width: '100%'}" get-container="body">
      <van-datetime-picker type="year-month" title="选择年月" :min-date="new Date(2000, 0, 1)" :max-date="maxDate"
                           @confirm="onConfirmTime" @cancel="cancelTime" :filter="filter"/>
    </van-popup>
    <!--论文成绩状态-->
    <van-popup v-model="showScore" position="bottom" :close-on-click-overlay="false" get-container="body">
      <van-picker show-toolbar value-key="dictValue" title="选择论文成绩" :columns="scoreList" @cancel="cancelScore" @confirm="chooseScore"/>
    </van-popup>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    components: {},
    computed: {
      ...mapGetters({
        CONFIG_ITEM: 'enroll/configItem',
        USER_INFO: 'user/userInfo'
      }),
    },
    props:{
      register:{
        type:Object,
        default: () => {}
      }
    },
    data () {
      return {
        show:false,
        shower:false,
        isShow:false,
        showTime:false,
        showScore:false,
        areaShow:false,
        result:[],
        keMu:'',
        kaoDian:'',
        kaoQu:'',
        exam:{},
        siteList:[],
        subjectList:[],
        areaList:[],
        isList:[{name:'在籍',value:1},{name:'已毕业',value:0}],
        scoreList:[],
        examSubject: '',
        examSiteId: '',
        examRegions:'',
        userAddress: '',
        isName:'',
        isState:'',
        timeLine:'',
        theoryGrade:'',
        maxDate: new Date(this.dayjs().format('YYYY')+'/12/1')
      }
    },
    created () {

    },
    methods: {
      confirm(){
        let str = ''
        let arr = []
//        this.examSubject = this.result.join(',')
        this.result.forEach((item)=>{
          this.subjectList.forEach((ite)=>{
            if(item==ite.id){
              str=str+' '+ite.name
              arr.push(item)
            }
          })
        })
        this.examSubject = arr.join(',')
        this.keMu = str
        this.show = false
      },
      isNo(){
        this.show = false
        this.examSubject = ''
        this.keMu = ''
        this.result = []
      },
      toggle(index) {
        if(this.register.subjectMultiple==0){
          this.result = []
        }
        this.$refs.checkboxes[index].toggle()
      },
      chooseType(i){
        this.isShow = false
        this.kaoDian=i.name
        this.examSiteId =i.id
      },
      chooseArea(i){
        this.areaShow = false
        this.kaoQu = i.name
        this.examRegions = i.id
        if(this.register.siteRequired==1){
          this.kaoDian = ''
          this.examSiteId =''
          this.getSiteList(this.examRegions)
        }
      },
      chooseIs(i){
        this.shower = false
        this.isName = i.name
        this.isState = i.value
        this.timeLine = ''
        this.theoryGrade = ''
      },
      cancelOn(){
        this.isShow = false
        this.kaoDian=''
        this.examSiteId =''
      },
      cancelOnIs(){
        this.shower = false
        this.isName = ''
        this.isState = ''
        this.timeLine = ''
        this.theoryGrade = ''
      },
      cancelArea(){
        this.areaShow = false
        this.kaoQu = ''
        this.examRegions = ''
        if(this.register.siteRequired==1){
          this.kaoDian = ''
          this.examSiteId =''
        }
      },
      onConfirmTime(i){
        this.showTime = false
        this.timeLine = this.dayjs(i).format('YYYY-MM-DD hh:mm:ss')
      },
      cancelTime(){
        this.showTime = false
        this.timeLine = ''
      },
      chooseScore(i){
        this.showScore = false
        this.theoryGrade = i.dictValue
      },
      cancelScore(){
        this.showScore = false
        this.theoryGrade = ''
      },
      setOPen(){
        this.showScore = true
        this.http.getRequest({
          url:'app/exam/selectDictDataList',
          msg:{dictType:'sys_user_score'},
          success:(res)=>{
            this.scoreList = res.data ? res.data : []
          }
        })
      },
      filter(type, options) {
        if(type === 'month'){
          return options.filter((option) => (option == 6||option ==12));
        }
        return options;
      },
      getSiteList(i){
        this.http.getRequest({
          url: `/app/exam/querySiteInfoByRegions/${this.CONFIG_ITEM.id}/${i}`,
          msg: {},
          success: (res) => {
            this.siteList =res.data
          }
        })
      },
      setPopup(){
        if(this.USER_INFO.regionsId){
          if(this.kaoQu){
            this.utils.toastError('考生已绑定考区，无法修改！')
          } else {
            this.utils.toastError('考生绑定的考区与学位授予高校的考区不符合，请联系学位授予高校')
          }

        }else {
          this.areaShow = true
        }
      },
      setKaoQu(){
        this.kaoQu = ''
        this.examRegions = ''
        this.areaList.forEach((item)=>{
          if(this.USER_INFO.regionsId==item.id){
            this.kaoQu = item.name
            this.examRegions = item.id
            this.kaoDian = ''
            this.examSiteId =''
            this.getSiteList(this.examRegions)
          }
        })
      }
    },
    mounted () {

    },
    watch: {
      areaList:{
        handler(newVal, oldVal){
          if(this.USER_INFO.regionsId&&this.register.regionsRequired){
            this.setKaoQu()
          }
        },
        deep: true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
.m-pop{
  .x-font-color{
    font-weight: 600;
  }
  .m-item{
    align-items: baseline;
    margin-top: 20px;
    >span{
      display: block;
      white-space: nowrap;
      color: #8D8F93;
      width: 80px;
      margin-right: 20px;
      &::before{
        display: inline-block;
        content: "*";
        color: #FB2927;
        font-size: 18px;
      }
    }
    .m-span{
      margin-left: 7px;
      &::before{
        display: none!important;
      }
    }
    .m-right{
      text-align: right;
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: flex-end;
      .m-ple{
        color:  #8D8F93;
      }
      .m-ico{
        color:  #8D8F93;
        font-size: 16px;
      }
      /deep/.van-cell{
        line-height: normal;
        padding: 0;
      }
      /deep/.van-field__control{
        text-align: right;
      }
      /deep/.van-field__control::-webkit-input-placeholder{
        color: #8D8F93!important;
      }
      /deep/.van-field__control::-moz-placeholder{
        color: #8D8F93!important;
      }
      /deep/.van-field__control::-ms-input-placeholder{
        color: #8D8F93!important;
      }
    }
  }
  /deep/.van-popup--bottom.van-popup--round{
    border-radius: 10px 10px 0 0;
  }
}
  .m-title{
    left: 0;
    right: 0;
    position: absolute;
    display: flex;
    height: 65px;
    >div:nth-child(1),div:nth-child(3){
      font-size: 14px;
      padding: 0 16px;
      line-height: 65px;
    }
    >div:nth-child(2){
      flex: 1;
      text-align: center;
      line-height: 65px;
      font-size: 16px;
    }
  }
  .m-pop-content{
    position: absolute;
    left: 0;
    right: 0;
    top: 60px;
    bottom: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 100;
    background: #ffffff;
  }
</style>

